export {};
//# sourceMappingURL=SensitivityLabel.types.js.map